/** The re-split's previews (TMMAPP-0108, MM-D-125): fixed, then percent floored, then the rest. */
import type { AllocateMode } from '@/features/accounts/allocateRows';

/** What a preview reads of a row: its mode and the text typed. */
export interface PreviewRow {
  mode: AllocateMode;
  value: string;
}

/** Each row's previewed signed amount (fixed, then percent floored, then the rest); null = invalid. */
export function previewSplit(
  rows: readonly PreviewRow[],
  totalMinor: number,
  parseAmount: (text: string) => number | null,
  parseBp: (text: string) => number | null,
): Array<number | null> {
  const sign = totalMinor < 0 ? -1 : 1;
  const base = Math.abs(totalMinor);
  const out: Array<number | null> = rows.map((row) => {
    if (row.mode === 'amount') {
      const minor = parseAmount(row.value);
      return minor === null || minor <= 0 ? null : sign * minor;
    }
    if (row.mode === 'percent') {
      const bp = parseBp(row.value);
      return bp === null || bp < 1 || bp > 10000 ? null : sign * Math.floor((base * bp) / 10000);
    }
    return null;
  });
  const restIndex = rows.findIndex((row) => row.mode === 'rest');
  if (restIndex >= 0) {
    const placed = out.reduce<number>((sum, value) => sum + (value ?? 0), 0);
    out[restIndex] = totalMinor - placed;
  }
  return out;
}
